import { Box, Stack, Typography } from "@mui/material";
import ProfileAndCommentComponent from "./ProfileAndCommentComponent";
import PostCommentAndLikesShareComponent from "./PostCommentAndLikesShareComponent";

function SecondSectionAppHome({ posts = [], onPostUpdate }) {
  console.log("All Posts Data:", posts);

  // Default avatar URL - using the same default as navbar
  const defaultAvatar = "/images/navbar-profile-pic.jpeg";

  return (
    <Stack
      direction="column"
      id="create-post"
      sx={{
        bgcolor: "#ffffff",
        borderRadius: "24px",
        px: "20px",
        py: "16px",
      }}
      spacing={3}
    >
      {posts.map((post) => {
        // Debug logs
        console.log("Post User Data:", {
          userId: post.user?._id,
          firstName: post.user?.firstName,
          lastName: post.user?.lastName,
          profileImage: post.user?.profileImage,
          fullUserObject: post.user
        });

        return (
          <Box key={post._id}>
            <ProfileAndCommentComponent
              avatarSrc={post.user?.profileImage || defaultAvatar}
              primaryText={post.user ? `${post.user.firstName} ${post.user.lastName}` : "Unknown User"}
              secondaryText={new Date(post.createdAt).toLocaleString()}
              profile={true}
              menuOrImojiButton={{ src: "/icons/3dotsmenu.svg" }}
              postDescription={true}
            >
              <Typography variant="body2">{post.text}</Typography>
            </ProfileAndCommentComponent>

            <PostCommentAndLikesShareComponent post={post} onPostUpdate={onPostUpdate} />

            {post.comments && post.comments.length > 0 && (
              <Box sx={{ pl: "60px", mt: 2 }}>
                {post.comments.map((c) => {
                  // Debug logs for comments
                  console.log("Comment User Data:", {
                    userId: c.user?._id,
                    firstName: c.user?.firstName,
                    lastName: c.user?.lastName,
                    profileImage: c.user?.profileImage,
                    fullUserObject: c.user
                  });

                  return (
                    <ProfileAndCommentComponent
                      key={c._id}
                      avatarSrc={c.user?.profileImage || defaultAvatar}
                      primaryText={c.user ? `${c.user.firstName} ${c.user.lastName}` : "Unknown User"}
                      secondaryText={new Date(c.createdAt).toLocaleString()}
                      commentDescription
                      menuOrImojiButton={{
                        src: "/icons/heart-emoji.svg",
                        text: "02",
                      }}
                    >
                      <Typography variant="body2">{c.text}</Typography>
                    </ProfileAndCommentComponent>
                  );
                })}
              </Box>
            )}
          </Box>
        );
      })}
    </Stack>
  );
}

export default SecondSectionAppHome;
